import gql from 'graphql-tag';

import { WATCH_TYPE } from 'src/app/constants/video';
import { Program } from 'src/app/models/program';

export interface LivePolling {
  id: string;
  isCurrentlyLive: boolean;
  isChatEnabled: boolean;
  stickyChat: string;
  viewCount: number;
  totalViewCount: number;
  officialAccountIds: number[];
  showOnlineUsers: boolean;
}

export interface Live extends LivePolling {
  description: string;
  publishedAt: string;
  score: {
    like: number;
    dislike: number;
    userScore: string;
  };
  thumbnail: string;
  title: string;
  type: WATCH_TYPE;
  desktopBackground?: string;
  mobileBackground?: string;
  isAnonymousChatEnabled?: boolean;
}

export interface LiveScheduleItem {
  id: string;
  title: string;
  publishedAt: string;
  program: Program;
}

export interface LiveForSchema extends Live {
  embedUrl: string;
  largeThumbnail: string;
  program: {
    channel: {
      avatar: string;
      name: string;
    };
  };
}

export const LIVE_POLLING_FRAGMENT = gql`
  fragment LivePolling on GQLLive {
    id
    isCurrentlyLive
    isChatEnabled
    stickyChat
    viewCount
    totalViewCount
    officialAccountIds
    showOnlineUsers
  }
`;

export const LIVE_FRAGMENT = gql`
  fragment Live on GQLLive {
    ...LivePolling
    description
    publishedAt
    score {
      like
      dislike
      userScore
    }
    thumbnail
    title
    type
    desktopBackground
    mobileBackground
    isAnonymousChatEnabled
  }
  ${LIVE_POLLING_FRAGMENT}
`;
